import authAxios from "../axios-instance/authAxios";

const MAIN_API_HOST = process.env.REACT_APP_MAIN_API_HOST;

export const InflowAnalyticsApi = {
    getInflowAnalytics,
    getLinkAnalytics,
}

// 링크 하나의 클릭 상세 (슈룩 Pro)
async function getLinkAnalytics({ headers, userPageId, linkItemId, params }) {
    return await authAxios.get(`${MAIN_API_HOST}/v2/public/inflow-analytics/${userPageId}/links/${linkItemId}`, {
        headers: headers,
        params: params,
    })
}

async function getInflowAnalytics({ headers, userPageId, params }) {
    return await authAxios.get(`${MAIN_API_HOST}/v2/public/inflow-analytics/${userPageId}`, {
        headers: headers,
        params: params,
    })
}
